export const markerX = 68;
export const markerY = 60;
export const regularMarkerX = 30;
export const regularMarkerY = 30;
export const activeMarkerX = 48;
export const activeMarkerY = 60;
